import { Outlet } from "react-router-dom"

export default function Ovks() {
    return (<Outlet />)
}